import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { media } from "@atlaskit/primitives/responsive";

import { useLocalizedHref } from "@/libraries/web-framework";

import ResourceCard, {
    ResourceCardContentProps
} from "../../../../contact/enterprise-contact-sales-page/sections/resource-card";

const wrapperCardStyle = css({
    position: "relative",
    boxSizing: "border-box",
    clear: "both",
    display: "block",
    minWidth: "100%",
    paddingBlockEnd: "16px",
    paddingBlockStart: "16px"
});

const resourceCardsStyling = css({
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "row",
    marginInlineStart: "auto",
    marginInlineEnd: "auto",
    maxWidth: "1200px",
    [media.below.sm]: {
        flexDirection: "column"
    }
});

const ResourceCards = () => {
    const intl = useIntl();

    const roadMapsText = intl.formatMessage({
        id: "EnterpriseContactPageTemplate.ConfirmationPage.ResourceCard.ViewRoadmaps",
        defaultMessage: "View roadmaps"
    });
    const advancedFeaturesText = intl.formatMessage({
        id: "EnterpriseContactPageTemplate.ConfirmationPage.ResourceCard.AdvancedFeatures",
        defaultMessage: "See advanced features"
    });
    const browseResourcesText = intl.formatMessage({
        id: "EnterpriseContactPageTemplate.ConfirmationPage.ResourceCard.BrowseResources",
        defaultMessage: "Browse resources"
    });

    const resourceCards: ResourceCardContentProps[] = [
        {
            header: intl.formatMessage({
                id: "EnterpriseContactPageTemplate.ConfirmationPage.ResourceCard.FeatureRoadmaps",
                defaultMessage: "Feature Roadmaps"
            }),
            description: intl.formatMessage({
                id: "EnterpriseContactPageTemplate.ConfirmationPage.ResourceCard.FeatureRoadmaps.dsc",
                defaultMessage:
                    "See what's in our pipeline for Cloud and Data Center products."
            }),
            buttonText: roadMapsText,
            url: useLocalizedHref("/roadmap/cloud")
        },
        {
            header: intl.formatMessage({
                id: "EnterpriseContactPageTemplate.ConfirmationPage.ResourceCard.CloudPremium",
                defaultMessage: "Cloud Premium products"
            }),
            description: intl.formatMessage({
                id: "EnterpriseContactPageTemplate.ConfirmationPage.ResourceCard.CloudPremium.dsc",
                defaultMessage:
                    "Learn about advanced product features for enterprises."
            }),
            buttonText: advancedFeaturesText,
            url: useLocalizedHref("/software/premium")
        },
        {
            header: intl.formatMessage({
                id: "EnterpriseContactPageTemplate.ConfirmationPage.ResourceCard.EnterpriseResources",
                defaultMessage: "More enterprise resources"
            }),
            description: intl.formatMessage({
                id: "EnterpriseContactPageTemplate.ConfirmationPage.ResourceCard.EnterpriseResources.dsc",
                defaultMessage:
                    "View resources, filtered by Cloud and Data Center product features."
            }),
            buttonText: browseResourcesText,
            url: useLocalizedHref(
                "/enterprise/resources?format=&topic=product-features&platform="
            )
        }
    ];

    return (
        <div css={wrapperCardStyle}>
            <div css={resourceCardsStyling}>
                {resourceCards.map((cardProps) => (
                    <ResourceCard
                        {...cardProps}
                        key={cardProps.header}
                        type="primary"
                        color="grey"
                    />
                ))}
            </div>
        </div>
    );
};

export default ResourceCards;
